import { useServiceBookingState } from '../context/ServiceBookingState';
import { Form } from '../Components/Form';
import * as React from 'react';
import { StepProps } from '../../types';

export default function LocationSelection({ form, setForm, onStepCompleted }: StepProps) {
    const { locations } = useServiceBookingState();

    const handleSubmit = (e: any) => {
        e.preventDefault();
        // Form submission handled by location selection
    };

    // Handle location selection - works for both new selections and re-clicking the same option
    const handleLocationSelect = (betriebsnummer: number) => {
        setForm((f) => ({
            ...f,
            standort_betriebsnummer: betriebsnummer,
        }));
        onStepCompleted();
    };

    return (
        <Form className="mx-auto max-w-md" onSubmit={handleSubmit}>
            <div className="space-y-4">
                {locations.map((location) => {
                    const isSelected = form?.standort_betriebsnummer === location.betriebsnummer;

                    return (
                        <button
                            key={location.betriebsnummer}
                            type="button"
                            aria-label={location.standort}
                            className={`group relative block w-full cursor-pointer gap-4 border-2 px-4 py-4 text-left
                            sm:flex sm:items-center sm:justify-between
                            ${
                                isSelected
                                    ? 'border-primary bg-primary text-white'
                                    : 'border-secondary-500 bg-white hover:border-primary-300'
                            }`}
                            onClick={() => handleLocationSelect(location.betriebsnummer)}
                        >
                            <div className="flex items-center">
                                <span
                                    className={`relative flex h-[1.25rem] w-[1.25rem] shrink-0 items-center justify-center rounded-full border-2 transition-all duration-300 ${
                                        isSelected ? 'border-white bg-white' : 'border-secondary-500 bg-white'
                                    }`}
                                >
                                    {isSelected && (
                                        <svg
                                            className="h-2 w-2 text-primary"
                                            viewBox="0 0 20 20"
                                            fill="none"
                                            stroke="currentColor"
                                            strokeWidth="4"
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                        >
                                            <path d="M4 10l4 4 8-8" />
                                        </svg>
                                    )}
                                </span>
                            </div>
                            <div className="ml-3 flex grow flex-col sm:ml-4">
                                <div className="font-bold">{location.standort}</div>
                                <div className={`text-sm italic ${isSelected ? 'text-white/80' : ''}`}>
                                    {location.adresse}
                                </div>
                            </div>
                        </button>
                    );
                })}
            </div>
        </Form>
    );
}
